import { TFormSchema } from "@/comn/hooks";
import {api} from "@/comn";

/*
 * Password Authentication Service
 * !== 비밀번호 인증 서비스 ==!
 */
export const BASE = {
    api: `${process.env.REACT_APP_SYSTEM_GROUP === "tancis" ? process.env.REACT_APP_API_PTLI : process.env.REACT_APP_API_PTLE}`
};

export const APIS = {
    processPwdAuth: (data: any) => api.post(`${BASE.api}/api/v1/ptl/comn/comn/usr/pwdAuth`, data)
}

export const ENUMS = {
      OK    : "OK"
    , CANCLE: "CANCLE"
}

export const SF_PWD_AUTH: TFormSchema = {
      id: "form_pwdAuth"
    , schema: {
          usrId  : { type: "text"}
        , pwd    : { type: "password", label: "L_PWD", maxLength: 30, required: true, labelSize: 3, controlSize: 8 }
        , lgnTp  : {
              type: "select"
            , options: [
                { label: "EXT"    , value: "EXT" }
              , { label: "INT"    , value: "INT" }
              , { label: "LCM"    , value: "LCM" }
              , { label: "OGA"    , value: "OGA" }
            ]
        }
    }
};

